
const mae_battery_alpg = [0.26530525, 0.25959513, 0.2518372, 0.24613534, 0.24497782, 0.24911511,
    0.25683308, 0.26404506, 0.26867837, 0.27505592, 0.2901002, 0.3142244,
    0.3387498, 0.35370234, 0.3566064, 0.35277572, 0.34989214, 0.35461476,
    0.3718471, 0.40341204, 0.4458715, 0.48905724, 0.5186012, 0.52451235,
    0.50990397, 0.49017283, 0.48264757, 0.4961926, 0.5277863, 0.5666302,
    0.6028752, 0.63533974, 0.6709816, 0.71520424, 0.7641008, 0.8083223,
    0.8410205, 0.8585015, 0.8578224, 0.83869356, 0.8065177, 0.7721026,
    0.74912196, 0.749796, 0.7773851, 0.81875694, 0.8463737, 0.83552355,
    0.7856425, 0.72421765, 0.6872897, 0.693783, 0.7338658, 0.7789409,
    0.80474436, 0.80775744, 0.8016213, 0.8003953, 0.8068888, 0.8142268,
    0.8145613, 0.8064716, 0.7979215, 0.80400217, 0.8363272, 0.88913035,
    0.9385486, 0.96019363, 0.94700366, 0.91287124, 0.8876119, 0.90778893,
    0.99612767, 1.1353576, 1.2656475, 1.3256993, 1.3087975, 1.268398,
    1.255993, 1.2668952, 1.2668952]

const mae_pv_alpg = [0.17787139, 0.17473888, 0.1701416, 0.16651085, 0.1659568, 0.16956267,
    0.17703845, 0.18697926, 0.19769974, 0.20743883, 0.2136461, 0.21340741,
    0.20620288, 0.19591218, 0.1882441, 0.18584532, 0.18711619, 0.18976727,
    0.19394493, 0.20139666, 0.21249904, 0.22447537, 0.2323815, 0.23297209,
    0.22868346, 0.22621346, 0.22953606, 0.23569049, 0.23867625, 0.23584746,
    0.22934373, 0.22295842, 0.21918923, 0.21879664, 0.22209077, 0.2299212,
    0.24233651, 0.25597265, 0.2646345, 0.2638887, 0.2544367, 0.24124186,
    0.23078041, 0.22824293, 0.23473561, 0.2459116, 0.25448164, 0.2557121,
    0.2509581, 0.24577056, 0.24495976, 0.24921255, 0.25471336, 0.2555834,
    0.24912411, 0.23930262, 0.23313487, 0.23370877, 0.23851378, 0.24362504,
    0.24710551, 0.248537, 0.2477527, 0.24504869, 0.24136768, 0.23742756,
    0.23359218, 0.23131117, 0.23307993, 0.23950705, 0.24801369, 0.25615615,
    0.26495272, 0.27920857, 0.30660614, 0.3540454, 0.42023614, 0.49216685,
    0.5517053, 0.58480436, 0.58480436]

export function computeCost(battery, pv) {
    let batteryCost = 0;

    if (battery < 5) {
        batteryCost = battery * 500;
    } else if (battery < 10) {
        batteryCost = battery * 450;
    } else {
        batteryCost = battery * 433;
    }

    // PV cost: £950 per kW
    const pvCost = pv * 950;

    return batteryCost + pvCost;
}

export function computeCostMin(battery, pv, i) {
    let batteryCost = 0;

    if (battery - mae_battery_alpg[i] < 5) {
        batteryCost = Math.max(0, (battery - mae_battery_alpg[i]) * 500);
    } else if (battery - mae_battery_alpg[i] < 10) {
        batteryCost = (battery - mae_battery_alpg[i]) * 450;
    } else {
        batteryCost = (battery - mae_battery_alpg[i]) * 433;
    }
    // PV cost: £950 per kW
    let pvCost = Math.max((0, pv - mae_pv_alpg[i]) * 950);
    return batteryCost + pvCost;
}

export function computeCostMax(i) {
    let batteryCost = 0;

    if (mae_battery_alpg[i] * 2 < 5) {
        batteryCost = mae_battery_alpg[i] * 2 * 500;
    } else if (mae_battery_alpg[i] * 2 < 10) {
        batteryCost = mae_battery_alpg[i] * 2 * 450;
    } else {
        batteryCost = mae_battery_alpg[i] * 2 * 433;
    }

    // PV cost: £950 per kW
    const pvCost = (mae_pv_alpg[i] * 2) * 950;

    return batteryCost + pvCost;
}

export function computeSavings(pvProduction, predictions, totalLoad, priceBuy, priceSell, i) {
    let sales = Math.max(0, (pvProduction * predictions[70 - i][1] - ((20 + i) / 100 * totalLoad)) * priceSell)
    let savings = (20 + i) / 100 * totalLoad * priceBuy
    return (sales + savings)
}

export function computeSavingsMin(pvProduction, predictions, totalLoad, priceBuy, priceSell, i) {
    let sales = Math.max(0, (pvProduction * (predictions[70 - i][1] - mae_pv_alpg[i]) - ((20 + i) / 100 * totalLoad)) * priceSell)
    let savings = (20 + i) / 100 * totalLoad * priceBuy
    return (sales + savings)
}

export function computeSavingsMax(pvProduction, totalLoad, priceBuy, priceSell, i) {
    let sales = (pvProduction * Math.abs(mae_pv_alpg[i] * 2) - ((20 + i) / 100 * totalLoad)) * priceSell
    return Math.max(0, sales)
}